import { RouteConfig } from 'vue-router';

const routes: Array<RouteConfig> = [
	{
		path: '',
		component: () => import('@/views/calendario-servizi/CalendarioServizi.vue'),
		meta: {
			title: 'services-calendar',
			acl: 'section.calendarioservizi'
		}
	}
];

export default routes;